import { createContext, useContext, useRef, useState, useCallback } from "react";
import ConfirmDialog from "@/components/ConfirmDialog";

const Ctx = createContext(() => Promise.resolve(false));
export const useConfirm = () => useContext(Ctx);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((opts) => new Promise((resolve) => {
    resolver.current = resolve;
    setState(opts || {});
  }), []);

  const done = (val) => {
    setState(null);
    if (resolver.current) { resolver.current(val); resolver.current = null; }
  };

  return (
    <Ctx.Provider value={confirm}>
      {children}
      <ConfirmDialog
        open={!!state}
        title={state?.title}
        message={state?.message}
        confirmLabel={state?.confirmLabel}
        danger={state?.danger !== false}
        onConfirm={() => done(true)}
        onClose={() => done(false)}
      />
    </Ctx.Provider>
  );
}
